import { AppAccountSettingRepository } from "@/domain/repository/app-account-setting-repository";

export class CheckUserIdAvailableUsecase {
  constructor(private readonly repo: AppAccountSettingRepository) {}

  execute(loginId: string) {
    return this.repo.checkUserIdAvailable({ loginId: loginId.toLowerCase() });
  }
}
